module.exports = __webpack_public_path__ + "img/hr-grass-1.6c66c3f9.png";